var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconBnpl128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_9046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0292 114.15C91.4325 114.15 113.647 91.9351 113.647 64.5318C113.647 37.1285 91.4325 14.9137 64.0292 14.9137C36.6259 14.9137 14.4111 37.1285 14.4111 64.5318C14.4111 91.9351 36.6259 114.15 64.0292 114.15Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9966 114.117C49.528 113.364 37.5827 108.326 28.1609 99.0013C18.7391 89.6769 14.1585 78.1762 14.4193 64.4991C16.3314 64.4991 20.145 64.4991 25.8602 64.4991C25.8195 68.5704 25.4187 78.7384 36.4602 91.0638C45.2956 100.965 57.6142 102.667 63.9966 102.667C63.9694 105.19 63.9694 109.007 63.9966 114.117Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0269 114.117C78.4955 113.364 90.4407 108.326 99.8625 99.0013C109.284 89.6769 113.865 78.1762 113.604 64.4991C111.692 64.4991 107.878 64.4991 102.163 64.4991C102.204 68.5704 102.605 78.7384 91.5632 91.0638C82.7278 100.965 70.4092 102.667 64.0269 102.667C64.054 105.19 64.054 109.007 64.0269 114.117Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0269 14.8812C78.4955 15.634 90.4407 20.6726 99.8625 29.997C109.284 39.3214 113.865 50.8222 113.604 64.4992C111.692 64.4992 107.878 64.4992 102.163 64.4992C102.204 60.428 102.605 50.26 91.5632 37.9345C82.7278 28.0329 70.4092 26.3315 64.0269 26.3315C64.054 23.8084 64.054 19.9917 64.0269 14.8812Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0292 114.15C91.4325 114.15 113.647 91.9351 113.647 64.5318C113.647 37.1285 91.4325 14.9137 64.0292 14.9137C36.6259 14.9137 14.4111 37.1285 14.4111 64.5318C14.4111 91.9351 36.6259 114.15 64.0292 114.15Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9963 102.667C85.0758 102.667 102.164 85.5787 102.164 64.4992C102.164 43.4198 85.0758 26.3315 63.9963 26.3315C42.9169 26.3315 25.8286 43.4198 25.8286 64.4992C25.8286 85.5787 42.9169 102.667 63.9963 102.667Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2637 54.3211H48.7295V84.8553H79.2637V54.3211Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9966 61.5934C73.1012 61.5934 73.9966 60.698 73.9966 59.5934C73.9966 58.4888 73.1012 57.5934 71.9966 57.5934C70.892 57.5934 69.9966 58.4888 69.9966 59.5934C69.9966 60.698 70.892 61.5934 71.9966 61.5934Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9966 61.5934C57.1012 61.5934 57.9966 60.698 57.9966 59.5934C57.9966 58.4888 57.1012 57.5934 55.9966 57.5934C54.892 57.5934 53.9966 58.4888 53.9966 59.5934C53.9966 60.698 54.892 61.5934 55.9966 61.5934Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6299 52.5633C71.6299 47.9129 68.2122 44.1431 63.9963 44.1431C59.7804 44.1431 56.3628 47.9129 56.3628 52.5633",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9966 102.667V114.117",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9966 14.8812V26.3315",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3784 64.4992H25.8287",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.164 64.4992H113.614",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_9046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconBnpl128);
export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL128.d35d9d5834fb6e8ac9e283495d4e6ce6.svg";
export { ForwardRef as ReactComponent };